import { createFileRoute } from "@tanstack/react-router";
import CanYouTakeAntidepressantsDuringTms from "@/pages/articles/CanYouTakeAntidepressantsDuringTms";
export const Route = createFileRoute(
  "/can-you-take-antidepressants-during-tms",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Can You Take Antidepressants During TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Yes, most patients stay on antidepressants during TMS. Learn how TMS and medication work together for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Can You Take Antidepressants During TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Yes, most patients stay on antidepressants during TMS. Learn how TMS and medication work together for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/can-you-take-antidepressants-during-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/can-you-take-antidepressants-during-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CanYouTakeAntidepressantsDuringTms />;
}
